import getValues from '../../defaultValues/getValue';
import { onRequest } from '../../defaultValues/onRequest';
import { getAvailability } from '../../services/availabilityService';
import i18n from '../../services/i18n.js';
import moment from 'moment';
import { getSpecialDestinations } from '../../services/availabilityService';
import { assignMarketToRequest } from '../MarketAPI';
import { getUserInformation } from '../Login/loginService';
import { cleanFilters, setFilters } from '../../actions/hotelsActions';
const _ = require('lodash');

export const isValueEmpty = (value) => value === undefined || value === null || value === '';
export const isArrayEmpty = (value) => Array.isArray(value) && value.length === 0;
export const isObjectEmpty = (value) => typeof value === 'object' && Object.entries(value).length === 0;

export const setSelectedSuggestionFactory = (component, prop) => {
    return (suggestion) => {
        let val = suggestion && suggestion.formattedName ? suggestion.formattedName : '';
        let thestate = { selectedSuggestion: suggestion };
        if (prop === undefined) {
            prop = 'value';
            thestate[prop] = val;
        } else {
            thestate[prop] = suggestion;
            thestate.value = val;
        }
        component.setState(thestate);
    };
};

export const getAvailabilityWithParams = async (location, component) => {
    if (!location || !location.search) {
        return;
    }
    const { t } = component.props;
    const params = new URLSearchParams(location.search);
    const hotelCode = params.get('hotelCode');
    const cityCode = params.get('cityCode');
    const provinceCode = params.get('provinceCode');
    const coastCode = params.get('coastCode');
    const countryCode = params.get('countryCode');
    const checkIn = moment(params.get('checkIn'));
    const checkOut = moment(params.get('checkOut'));
    const rooms = Number(params.get('rooms'));
    const adults = getAdults(params, rooms);
    const children = getChildren(params, rooms);

    function isURLValid() {
        const error = t('RESULTS.BAD_URL');
        if (!hotelCode && !provinceCode && !cityCode && !coastCode) {
            throw new Error(error);
        }
        if (hotelCode && (provinceCode || cityCode || coastCode)) {
            throw new Error(error);
        }
        if (cityCode && (!countryCode || !provinceCode)) {
            throw new Error(error);
        }
        if (cityCode && coastCode) {
            throw new Error(error);
        }
        if (provinceCode && !countryCode) {
            throw new Error(error);
        }
        if (provinceCode && coastCode) {
            throw new Error(error);
        }
        if (provinceCode && coastCode && cityCode) {
            throw new Error(error);
        }
        if (!params.get('checkIn') || !params.get('checkOut')) {
            throw new Error(error);
        }
        if (!adults || !rooms || (adults.length !== rooms) || adults.some(el => el === 0)) {
            throw new Error(error);
        }
    }

    try {

        isURLValid();

        const checkInFormatted = moment(checkIn).format('DD/MM/YYYY');
        const nights = checkOut.diff(checkIn, 'days');
        let opts = {
            checkInDate: checkInFormatted,
            nights: nights,
            rooms: getRooms(adults, children, 'ALL', rooms),
        };
        const exclusiveFormSelected = false;

        let hotels = [];

        if (!hotelCode) {
            opts = Object.assign(opts, {
                countryCode: countryCode,
                stateCode: provinceCode,
                townCode: cityCode,
                coastCode: coastCode
            });
            hotels = null;
        } else { // Es un hotel!
            opts = Object.assign(opts, {
                hotels: [hotelCode]
            });
            hotels = [hotelCode];
        }
        if (hotels) {
            opts.hotels = hotels;
        }

        let result = null;

        const currentUser = getUserInformation();
        const accountName = currentUser ? currentUser.accountName.toLowerCase() : 'default';
        opts.allowRQ = getValues(onRequest, accountName);
        const useEroskiURL = exclusiveFormSelected && (accountName === 'b2bweberoski' || accountName === 'Nautalia');

        opts.type = 'hotels';
        if (opts.destination) {
            opts.type = 'experience';
        }
        if (useEroskiURL) {
            opts.type = 'exclusive';
        }

        assignMarketToRequest(opts);
        result = await getAvailability(opts, useEroskiURL);
        localStorage.setItem(result.requestCode, JSON.stringify(result));
        return result;
    } catch (error) {
        component.setState({ loading: false, backendmessage: error.message });
        if (component.props.parentHandler) {
            component.props.parentHandler('error', error);
        }
        if (component.handleFault) {
            component.handleFault(error);
        }
    }
};

export function getAdults(params, rooms) {
    let adults = [];
    for (let i = 1; i < rooms + 1; i++) {
        const adult = `adults_${i}`;
        adults.push(Number(params.get(adult)));
    }
    return adults;
}

export function getChildren(params, rooms) {
    const children = [];
    for (let i = 1; i < rooms + 1; i++) {
        const child = `childAges_${i}`;
        children.push(params.get(child));
    }
    return children.map(val => {
        if (val) {
            const split = val.split('-');
            return split.map(a => ({ age: Number(a) }));
        } else {
            return [];
        }
    });
}

export function getRooms(adults, children, mealPlan = 'ALL', rooms) {
    const roomsArray = [];
    for (let i = 0; i < rooms; i++) {
        roomsArray.push({
            adults: adults[i],
            kids: children[i],
            mealPlan: mealPlan
        });
    }
    return roomsArray;
}

export const handleSubmitFactory = (component) => {
    return () => {

        const { state } = component;

        if (state.isHotelListForm && isValueEmpty(state.exclusiveDestinationSelected)) {
            alert(i18n.t('ALERT.SELECT_DESTINATION'));
            component.setState({ inputError: true });
            return;
        }


        if (state.isDestListForm && isValueEmpty(state.exclusiveDestinationSelected)) {
            alert(i18n.t('ALERT.SELECT_DESTINATION'));
            component.setState({ inputError: true });
            return;
        }

        if (!state.isHotelListForm && !state.isDestListForm && (!state.selectedSuggestion || !state.selectedSuggestion.id)) {
            alert(i18n.t('ALERT.SELECT_DES_ZONE_HOT'));
            component.setState({ inputError: true });
            return;
        }

        let adults = state.rooms.reduce((acc, r) => acc + r.adults, 0);

        if (adults < 1) {
            alert(i18n.t('ALERT.SELECT_AT_LEAST'));
            component.setState({ inputError: true });
            return;
        }

        if (state.nights > process.env.REACT_APP_SEARCH_MAX_NIGHTS) {
            alert(i18n.t('ALERT.NIGTH_RANGE_EXCEED', { max: process.env.REACT_APP_SEARCH_MAX_NIGHTS }));
            return;
        }

        component.setState({ inputError: false });
        if (component.props.parentHandler) {
            component.props.parentHandler('search', null);
        }

        getAvailabilityFactory(component).then(data => {
            if (component.props && component.props.dispatch) {
                // Clear filters saved when new search in fired.
                component.props.dispatch(cleanFilters());
                const histogram = data && data.histogram ? data.histogram : data;
                // Set the new filters
                component.props.dispatch(setFilters({ histogram }))
            }
            handleResult(component, data);
        }).catch(error => {
            alert(error.message);
        });
    };
};

const getAvailabilityFactory = async (component) => {

    try {
        let opts = {
            checkInDate: moment(component.state.checkIn).format('DD/MM/YYYY'),
            nights: component.state.nights,
            rooms: component.state.rooms,
        };
        let exclusiveFormSelected = false;

        let hotels = component.state.hotels;
        
        const isExclusiveDestination = (
            Array.isArray(component.state.exclusiveDestinationSelected) && !isArrayEmpty(component.state.exclusiveDestinationSelected) ||
            !isValueEmpty(component.state.exclusiveDestinationSelected)
        )

        // if is hotel list search form
        if (component.state.isHotelListForm && isExclusiveDestination) {
            opts = Object.assign(opts, { 
                hotels: component.state.exclusiveDestinationSelected
            });
            hotels = component.state.exclusiveDestinationSelected;
            exclusiveFormSelected = true;
        }

        // if is a destination search
        if (component.state.isDestListForm && isExclusiveDestination) {

            let compData = JSON.parse(component.state.exclusiveDestinationSelected);

            opts = Object.assign(opts, {
                stateCode: compData.countryDivisionId,
                townCode: compData.cityId,
                coastCode: compData.coastId,
                countryCode: compData.countryId,
            });

            exclusiveFormSelected = true;
        }


        if (!component.state.isDestListForm && !component.state.isHotelListForm) {
            // used for suggestions from full text search
            if (Array.isArray(component.state.selectedSuggestion.code)) {
                opts = Object.assign(opts, {
                    countryCode: component.state.selectedSuggestion.code[0],
                    stateCode: component.state.selectedSuggestion.code[1],
                    townCode: component.state.selectedSuggestion.code[2],
                });
                hotels = null;
            } else if (component.state.selectedSuggestion.code) { // Es un hotel!
                opts = Object.assign(opts, {
                    hotels: [component.state.selectedSuggestion.code]
                });
                hotels = [component.state.selectedSuggestion.code];
            }
            if (hotels) {
                opts.hotels = hotels;
            }
        }

        opts.selectedSuggestion = component.state.selectedSuggestion;

        let obj = _.cloneDeep(component.state);
        obj.exclusiveFormSelected = exclusiveFormSelected;
        localStorage.setItem('searchContentState', JSON.stringify(obj));


        let result = null;
        const accountName = component.accountName;
        opts.allowRQ = getValues(onRequest, accountName);

        opts.type = 'hotels';

        assignMarketToRequest(opts);

        component.setState({ loading: true });
        result = await getAvailability(opts, false);
        component.setState({ loading: false });
        return result;
    } catch (error) {
        component.setState({ loading: false, backendmessage: error.message });
        if (component.props.parentHandler) {
            component.props.parentHandler('error', error);
        }
        if (component.handleFault) {
            component.handleFault(error, error.query);
        }
    }
};

const handleResult = (component, data) => {
    if (data && data.requestCode) {
        let type = data.request.type || 'hotels';
        type = component.accountName === 'Nautalia' && component.state.exclusiveFormSelected ? 'exclusive-nautalia' : type;
        localStorage.setItem(data.requestCode, JSON.stringify(data));
        window.location.href = '/#/results/' + type + '/' + data.requestCode;
    }
    if (component.resultHandler) {
        component.resultHandler('result', data);
    }
    if (component.props.parentHandler) {
        component.props.parentHandler('result', data);
    }

};

export const handleEroskiDestinationChangeFactory = (component) => {
    return (destinationId) => {
        component.setState({
            exclusiveDestinationSelected: destinationId,
        });
    };
};

export const handleDawsonDestinationChangeFactory = (component) => {
    return (destination) => {
        setSelectedSuggestionFactory(component)(destination);
        component.setState({
            exclusiveDestinationSelected: destination,
        });
    };
};

export const handleDestinationChangeFactory = (component) => {

    return (destination) => {
        setSelectedSuggestionFactory(component)(destination);
    };
};


export const componentDidMountFactory = (component) => {
    return () => {
    };
};


function Capitalizmo(string) {
    return string.length >= 2 ?
        string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : string;
}

export function commonValidateAndCase(text) {
    let haspoint = (text || '').match(/(([^\s.]+){2}|\s+?)/gi);
    if (haspoint) {
        haspoint.map(k => {
            text = text.replace(k, Capitalizmo(k));
        });
        return text;
    }
    return (text || '');
}



// WEBPACK FOOTER //
// ./src/components/SearchContent/CommonFunctions.js